@if (businessPartnerId(); as businessPartnerId) {
  <pfx-dashboard-layout [refresh]="businessPartner()?._id">
    <ng-template pfxTemplate>
      <pfx-panel
        title="Notizen"
        [toggleable]="true"
        [scrollableContent]="true"
      >
        <pfx-dialog>
          <pfx-notes-form [businessPartnerId]="businessPartnerId"></pfx-notes-form>
        </pfx-dialog>
      </pfx-panel>
    </ng-template>

    @if (isIndividual()) {
      <ng-template pfxTemplate>
        <pfx-task-list-widget
          [filter]="taskListWidgetFilter()"
          [url]="urlToTicketTab()"
        ></pfx-task-list-widget>
      </ng-template>
    }
    @if (isDependent()) {
      <ng-template pfxTemplate>
        <pfx-documentation-active-caregiver-stats
          [businessPartnerId]="businessPartnerId"
        ></pfx-documentation-active-caregiver-stats>
      </ng-template>
      <ng-template pfxTemplate>
        <pfx-documentation-care-consultation-stats
          [businessPartnerId]="businessPartnerId"
        ></pfx-documentation-care-consultation-stats>
      </ng-template>
    }

    @if (isDependent()) {
      <!-- ng-template pfxTemplate>
        <pfx-panel
          title="Kontakte (5)"
          [toggleable]="true"
          [scrollableContent]="true"
        >
          <div class="mb-4">
            <pfx-panel-group
              [items]="[
                {
                  title: { text: 'title 1' },
                  subtitle: [{ text: 'subtitle 1' }]
                },
                {
                  title: { text: 'title 2' },
                  subtitle: [{ text: 'subtitle 2' }]
                },
                {
                  title: { text: 'title 3' },
                  subtitle: [{ text: 'subtitle 3' }]
                },
                {
                  title: { text: 'title 4' },
                  subtitle: [{ text: 'subtitle 4' }]
                },
                {
                  title: { text: 'title 5' },
                  subtitle: [{ text: 'subtitle 5' }]
                }
              ]"
            >
              <ng-template
                [pfxTemplate]="PanelTemplateType.CONTENT"
                let-details
              >
                @for (detail of details; track detail) {
                  <div
                    style="border: 1px solid lightgray; padding: 0.375rem"
                    class="flex flex-col items-start mb-1"
                  >
                    <strong>{{ detail.title }}</strong>
                    <span>{{ detail.subtitle }}</span>
                    <small>{{ detail.description }}</small>
                  </div>
                }
              </ng-template>
            </pfx-panel-group>
          </div>

          <div class="text-center">
            <a href="">alle Kontakte zeigen</a>
          </div>
        </pfx-panel>
      </ng-template-->
    }

    @if (isInternalCaregiver() || isDependent()) {
      <!-- ng-template pfxTemplate>
        <pfx-panel
          title="Termine (7)"
          [toggleable]="true"
          [scrollableContent]="true"
        >
          <div class="mb-4">
            <pfx-panel-group
              [items]="[
                {
                  title: {
                    icon: icons.futureAppointment?.icon,
                    text: 'title 1'
                  },
                  subtitle: [{ text: 'subtitle 1' }],
                  description: [{ text: 'description 1' }],
                  details: [
                    { icon: 'details icon 1', text: 'details text 1' },
                    { icon: 'details icon 1', text: 'details text 1' },
                    { icon: 'details icon 1', text: 'details text 1' },
                    { icon: 'details icon 1', text: 'details text 1' }
                  ]
                },
                {
                  title: {
                    icon: icons.deletedAppointment?.icon,
                    iconColor: icons.deletedAppointment?.iconColor,
                    text: 'title 2'
                  },
                  severity: 'warn',
                  subtitle: [{ text: 'subtitle 2' }],
                  description: [{ text: 'description 2' }],
                  details: [
                    { icon: 'details icon 2', text: 'details text 2' },
                    { icon: 'details icon 2', text: 'details text 2' },
                    { icon: 'details icon 2', text: 'details text 2' },
                    { icon: 'details icon 2', text: 'details text 2' }
                  ]
                },
                {
                  title: { icon: icons.pastAppointment?.icon, text: 'title 3' },
                  subtitle: [{ text: 'subtitle 3' }],
                  description: [{ text: 'description 3' }],
                  details: [
                    { icon: 'details icon 3', text: 'details text 3' },
                    { icon: 'details icon 3', text: 'details text 3' },
                    { icon: 'details icon 3', text: 'details text 3' },
                    { icon: 'details icon 3', text: 'details text 3' }
                  ]
                },
                {
                  title: {
                    icon: icons.conflictingAppointment?.icon,
                    iconColor: icons.conflictingAppointment?.iconColor,
                    text: 'title 4'
                  },
                  severity: 'error',
                  subtitle: [{ text: 'subtitle 4' }],
                  description: [{ text: 'description 4' }],
                  details: [
                    { icon: 'details icon 4', text: 'details text 4' },
                    { icon: 'details icon 4', text: 'details text 4' },
                    { icon: 'details icon 4', text: 'details text 4' },
                    { icon: 'details icon 4', text: 'details text 4' }
                  ]
                },
                {
                  title: { icon: icons.futureAppointment?.icon, text: 'title 5' },
                  subtitle: [{ text: 'subtitle 5' }],
                  description: [{ text: 'description 5' }],
                  details: [
                    { icon: 'details icon 5', text: 'details text 5' },
                    { icon: 'details icon 5', text: 'details text 5' },
                    { icon: 'details icon 5', text: 'details text 5' },
                    { icon: 'details icon 5', text: 'details text 5' }
                  ]
                }
              ]"
            >
              <ng-template
                [pfxTemplate]="PanelTemplateType.CONTENT"
                let-details
              >
                <div
                  style="border: 1px dotted coral; padding: 0.375rem"
                  class="flex flex-col items-start mb-1"
                >
                  @for (detail of details; track detail) {
                    <div>
                      <strong>{{ detail.icon }} </strong>
                      <span>{{ detail.text }} </span>
                    </div>
                  }
                </div>
              </ng-template>
            </pfx-panel-group>
          </div>

          <div class="text-center">
            <a href="">alle Termine zeigen</a>
          </div>
        </pfx-panel>
      </ng-template-->

      <!--ng-template pfxTemplate>
        <pfx-panel
          title="Aufträge (7)"
          [toggleable]="true"
          [scrollableContent]="true"
        >
          <div class="mb-4">
            <pfx-panel-group
              [items]="[
                {
                  title: {
                    icon: icons.orderWithFutureAppointment?.icon,
                    iconColor: icons.orderWithFutureAppointment?.iconColor,
                    text: 'title 1'
                  },
                  severity: 'success',
                  subtitle: [{ text: 'subtitle 1' }],
                  description: [{ text: 'description 1' }],
                  details: [
                    { icon: 'details icon 1', text: 'details text 1' },
                    { icon: 'details icon 1', text: 'details text 1' },
                    { icon: 'details icon 1', text: 'details text 1' },
                    { icon: 'details icon 1', text: 'details text 1' }
                  ]
                },
                {
                  title: {
                    icon: icons.orderWithPastAppointment?.icon,
                    iconColor: icons.orderWithPastAppointment?.iconColor,
                    text: 'title 2'
                  },
                  severity: 'warn',
                  subtitle: [{ text: 'subtitle 2' }],
                  description: [{ text: 'description 2' }],
                  details: [
                    { icon: 'details icon 2', text: 'details text 2' },
                    { icon: 'details icon 2', text: 'details text 2' },
                    { icon: 'details icon 2', text: 'details text 2' },
                    { icon: 'details icon 2', text: 'details text 2' }
                  ]
                },
                {
                  title: {
                    icon: icons.orderWithoutAppointment?.icon,
                    iconColor: icons.orderWithoutAppointment?.iconColor,
                    text: 'title 3'
                  },
                  severity: 'error',
                  subtitle: [{ text: 'subtitle 3' }],
                  description: [{ text: 'description 3' }],
                  details: [
                    { icon: 'details icon 3', text: 'details text 3' },
                    { icon: 'details icon 3', text: 'details text 3' },
                    { icon: 'details icon 3', text: 'details text 3' },
                    { icon: 'details icon 3', text: 'details text 3' }
                  ]
                },
                {
                  title: {
                    icon: icons.closedOrder?.icon,
                    iconColor: icons.closedOrder?.iconColor,
                    text: 'title 4'
                  },
                  severity: 'success',
                  subtitle: [{ text: 'subtitle 4' }],
                  description: [{ text: 'description 4' }],
                  details: [
                    { icon: 'details icon 4', text: 'details text 4' },
                    { icon: 'details icon 4', text: 'details text 4' },
                    { icon: 'details icon 4', text: 'details text 4' },
                    { icon: 'details icon 4', text: 'details text 4' }
                  ]
                },
                {
                  title: {
                    icon: icons.closedOrder?.icon,
                    iconColor: icons.closedOrder?.iconColor,
                    text: 'title 5'
                  },
                  severity: 'success',
                  subtitle: [{ text: 'subtitle 5' }],
                  description: [{ text: 'description 5' }],
                  details: [
                    { icon: 'details icon 5', text: 'details text 5' },
                    { icon: 'details icon 5', text: 'details text 5' },
                    { icon: 'details icon 5', text: 'details text 5' },
                    { icon: 'details icon 5', text: 'details text 5' }
                  ]
                }
              ]"
            >
              <ng-template
                [pfxTemplate]="PanelTemplateType.CONTENT"
                let-details
              >
                <div
                  style="border: 1px dotted coral; padding: 0.375rem"
                  class="flex flex-col items-start mb-1"
                >
                  @for (detail of details; track detail) {
                    <div>
                      <strong>{{ detail.icon }} </strong>
                      <span>{{ detail.text }} </span>
                    </div>
                  }
                </div>
              </ng-template>
            </pfx-panel-group>
          </div>

          <div class="text-center">
            <a href="">alle Aufträge zeigen</a>
          </div>
        </pfx-panel>
      </ng-template-->
    }
  </pfx-dashboard-layout>
}
